export const ZORAX_DEFER = 'zorax.defer'
export const ZORAX_DEFER_PRINT = 'zorax.defer.print'
export const ZORAX_GROUP = 'zorax.defer.group'
export const ZORAX_ONLY = 'zorax.defer.only'
export const ZORAX_MACRO = 'zorax.macro'
